import { User } from '@auth0/auth0-react';

export interface TOwnerCourseViewModel {
  courseID: number;
  isShared: boolean;
  sharedCount: number;
  coursePageCount: number;
  sharedToOwner: boolean;
  staticInfoGroup: TStaticInfoGroup;
  sharedUsers: ISharedUsers;
}

export interface TStaticInfoGroup {
  caption: string;
  items: IStaticInfoGroup;
}
export interface IStaticInfoGroup {
  caption: string;
  title: TStaticInfo;
  description: TStaticInfo;
  modifiedDate: TStaticInfo;
  createdDate: TStaticInfo;
  status: TStaticInfo;
  avatar: TStaticInfo;
  lastPageVisited: TStaticInfo;
}

export interface ISharedUsers {
  courseID: number;
  users: User[];
}

export interface TStaticInfo {
  caption: string;
  value: string;
  propertyValueID: number;
}

export enum EOwnerCourseListSortByType {
  Created = 1,
  Altered,
  Title,
}

export interface ICopyPageObject {
  source: ICopyPageData;
  dest: ICopyPageData;
  copyChildPages: boolean;
  index: number;
  numberOfChildren: number;
}

export interface ICopyPageData {
  courseID: number;
  coursePageID: number;
}
